@file:OptIn(InternalResourceApi::class)

package rainbowclubs.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/rainbowclubs.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_670_860_142)
internal val Res.string.accept: StringResource by lazy {
      StringResource("string:accept", "accept", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 22),
      ))
    }

@delegate:ResourceContentHash(1_454_739_874)
internal val Res.string.add_comment_placeholder: StringResource by lazy {
      StringResource("string:add_comment_placeholder", "add_comment_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33, 55),
      ))
    }

@delegate:ResourceContentHash(738_696_675)
internal val Res.string.add_field: StringResource by lazy {
      StringResource("string:add_field", "add_field", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89, 29),
      ))
    }

@delegate:ResourceContentHash(-1_895_755_489)
internal val Res.string.admin_actions: StringResource by lazy {
      StringResource("string:admin_actions", "admin_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 41),
      ))
    }

@delegate:ResourceContentHash(-457_493_888)
internal val Res.string.admin_banner_description: StringResource by lazy {
      StringResource("string:admin_banner_description", "admin_banner_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161, 88),
      ))
    }

@delegate:ResourceContentHash(1_351_343_980)
internal val Res.string.admin_dashboard_title: StringResource by lazy {
      StringResource("string:admin_dashboard_title", "admin_dashboard_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250, 49),
      ))
    }

@delegate:ResourceContentHash(32_830_324)
internal val Res.string.admin_icon_cd: StringResource by lazy {
      StringResource("string:admin_icon_cd", "admin_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 10, 37),
      ))
    }

@delegate:ResourceContentHash(-416_625_679)
internal val Res.string.admin_no_access_description: StringResource by lazy {
      StringResource("string:admin_no_access_description", "admin_no_access_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 300, 99),
      ))
    }

@delegate:ResourceContentHash(13_578_311)
internal val Res.string.admin_no_access_title: StringResource by lazy {
      StringResource("string:admin_no_access_title", "admin_no_access_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 400, 53),
      ))
    }

@delegate:ResourceContentHash(1_128_943_539)
internal val Res.string.admin_page_description: StringResource by lazy {
      StringResource("string:admin_page_description", "admin_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 454, 54),
      ))
    }

@delegate:ResourceContentHash(-1_442_567_393)
internal val Res.string.admin_screen_name: StringResource by lazy {
      StringResource("string:admin_screen_name", "admin_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 509, 33),
      ))
    }

@delegate:ResourceContentHash(-1_696_875_869)
internal val Res.string.approval: StringResource by lazy {
      StringResource("string:approval", "approval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 543, 28),
      ))
    }

@delegate:ResourceContentHash(619_338_493)
internal val Res.string.approved_at: StringResource by lazy {
      StringResource("string:approved_at", "approved_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 572, 35),
      ))
    }

@delegate:ResourceContentHash(619_360_441)
internal val Res.string.approved_by: StringResource by lazy {
      StringResource("string:approved_by", "approved_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 608, 35),
      ))
    }

@delegate:ResourceContentHash(-712_798_806)
internal val Res.string.attendance_failure_icon_cd: StringResource by lazy {
      StringResource("string:attendance_failure_icon_cd", "attendance_failure_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 48, 58),
      ))
    }

@delegate:ResourceContentHash(-1_904_774_420)
internal val Res.string.attendance_signed: StringResource by lazy {
      StringResource("string:attendance_signed", "attendance_signed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 644, 49),
      ))
    }

@delegate:ResourceContentHash(1_742_278_117)
internal val Res.string.attendance_signing: StringResource by lazy {
      StringResource("string:attendance_signing", "attendance_signing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 694, 54),
      ))
    }

@delegate:ResourceContentHash(-1_611_309_835)
internal val Res.string.attendance_success_icon_cd: StringResource by lazy {
      StringResource("string:attendance_success_icon_cd", "attendance_success_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 107, 58),
      ))
    }

@delegate:ResourceContentHash(-1_910_449_398)
internal val Res.string.attendance_try_again: StringResource by lazy {
      StringResource("string:attendance_try_again", "attendance_try_again", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 40),
      ))
    }

@delegate:ResourceContentHash(-563_182_441)
internal val Res.string.attendee_count: StringResource by lazy {
      StringResource("string:attendee_count", "attendee_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 790, 30),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
internal val Res.string.back_icon_cd: StringResource by lazy {
      StringResource("string:back_icon_cd", "back_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 166, 28),
      ))
    }

@delegate:ResourceContentHash(125_152_185)
internal val Res.string.calendar_icon_cd: StringResource by lazy {
      StringResource("string:calendar_icon_cd", "calendar_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 195, 44),
      ))
    }

@delegate:ResourceContentHash(-1_723_114_343)
internal val Res.string.camera_permission_button: StringResource by lazy {
      StringResource("string:camera_permission_button", "camera_permission_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 821, 48),
      ))
    }

@delegate:ResourceContentHash(-244_216_548)
internal val Res.string.camera_permission_description: StringResource by lazy {
      StringResource("string:camera_permission_description", "camera_permission_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 870, 101),
      ))
    }

@delegate:ResourceContentHash(-202_171_819)
internal val Res.string.camera_permission_title: StringResource by lazy {
      StringResource("string:camera_permission_title", "camera_permission_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 63),
      ))
    }

@delegate:ResourceContentHash(781_099_018)
internal val Res.string.camera_unavailable: StringResource by lazy {
      StringResource("string:camera_unavailable", "camera_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1036, 94),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1131, 22),
      ))
    }

@delegate:ResourceContentHash(-1_158_381_794)
internal val Res.string.change_club: StringResource by lazy {
      StringResource("string:change_club", "change_club", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1154, 35),
      ))
    }

@delegate:ResourceContentHash(261_867_371)
internal val Res.string.change_club_icon_cd: StringResource by lazy {
      StringResource("string:change_club_icon_cd", "change_club_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 240, 51),
      ))
    }

@delegate:ResourceContentHash(728_151_365)
internal val Res.string.chevron_icon_cd: StringResource by lazy {
      StringResource("string:chevron_icon_cd", "chevron_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 292, 39),
      ))
    }

@delegate:ResourceContentHash(-1_405_064_626)
internal val Res.string.choose_event: StringResource by lazy {
      StringResource("string:choose_event", "choose_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1190, 36),
      ))
    }

@delegate:ResourceContentHash(-1_328_680_098)
internal val Res.string.clear_search_icon_cd: StringResource by lazy {
      StringResource("string:clear_search_icon_cd", "clear_search_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 332, 44),
      ))
    }

@delegate:ResourceContentHash(-1_442_734_018)
internal val Res.string.club_about_title: StringResource by lazy {
      StringResource("string:club_about_title", "club_about_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1227, 44),
      ))
    }

@delegate:ResourceContentHash(673_036_981)
internal val Res.string.club_description_label: StringResource by lazy {
      StringResource("string:club_description_label", "club_description_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1272, 46),
      ))
    }

@delegate:ResourceContentHash(-1_727_932_119)
internal val Res.string.club_description_placeholder: StringResource by lazy {
      StringResource("string:club_description_placeholder", "club_description_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1319, 76),
      ))
    }

@delegate:ResourceContentHash(-1_985_729_247)
internal val Res.string.club_field_label: StringResource by lazy {
      StringResource("string:club_field_label", "club_field_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1462, 40),
      ))
    }

@delegate:ResourceContentHash(-1_095_594_511)
internal val Res.string.club_field_label_required: StringResource by lazy {
      StringResource("string:club_field_label_required", "club_field_label_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1396, 65),
      ))
    }

@delegate:ResourceContentHash(-806_742_724)
internal val Res.string.club_field_type: StringResource by lazy {
      StringResource("string:club_field_type", "club_field_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1503, 39),
      ))
    }

@delegate:ResourceContentHash(700_656_302)
internal val Res.string.club_form_error: StringResource by lazy {
      StringResource("string:club_form_error", "club_form_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1543, 75),
      ))
    }

@delegate:ResourceContentHash(277_214_077)
internal val Res.string.club_image_preview: StringResource by lazy {
      StringResource("string:club_image_preview", "club_image_preview", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1619, 50),
      ))
    }

@delegate:ResourceContentHash(-1_452_553_370)
internal val Res.string.club_image_selected: StringResource by lazy {
      StringResource("string:club_image_selected", "club_image_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1670, 47),
      ))
    }

@delegate:ResourceContentHash(1_807_090_061)
internal val Res.string.club_membership_data: StringResource by lazy {
      StringResource("string:club_membership_data", "club_membership_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1819, 48),
      ))
    }

@delegate:ResourceContentHash(1_286_644_286)
internal val Res.string.club_membership_data_description: StringResource by lazy {
      StringResource("string:club_membership_data_description", "club_membership_data_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1718, 100),
      ))
    }

@delegate:ResourceContentHash(-1_369_980_266)
internal val Res.string.club_name_label: StringResource by lazy {
      StringResource("string:club_name_label", "club_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1868, 35),
      ))
    }

@delegate:ResourceContentHash(1_683_678_250)
internal val Res.string.club_name_placeholder: StringResource by lazy {
      StringResource("string:club_name_placeholder", "club_name_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1904, 49),
      ))
    }

@delegate:ResourceContentHash(-2_131_288_911)
internal val Res.string.club_name_required: StringResource by lazy {
      StringResource("string:club_name_required", "club_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1954, 54),
      ))
    }

@delegate:ResourceContentHash(47_763_144)
internal val Res.string.club_page_label: StringResource by lazy {
      StringResource("string:club_page_label", "club_page_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2009, 31),
      ))
    }

@delegate:ResourceContentHash(837_322_727)
internal val Res.string.club_profile: StringResource by lazy {
      StringResource("string:club_profile", "club_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2041, 36),
      ))
    }

@delegate:ResourceContentHash(-1_899_567_607)
internal val Res.string.clubs_overview: StringResource by lazy {
      StringResource("string:clubs_overview", "clubs_overview", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2078, 54),
      ))
    }

@delegate:ResourceContentHash(-17_604_259)
internal val Res.string.comment_send_error: StringResource by lazy {
      StringResource("string:comment_send_error", "comment_send_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2133, 82),
      ))
    }

@delegate:ResourceContentHash(1_863_195_108)
internal val Res.string.comments: StringResource by lazy {
      StringResource("string:comments", "comments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2216, 28),
      ))
    }

@delegate:ResourceContentHash(1_307_884_781)
internal val Res.string.create_event_button: StringResource by lazy {
      StringResource("string:create_event_button", "create_event_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2245, 43),
      ))
    }

@delegate:ResourceContentHash(1_541_995_556)
internal val Res.string.create_event_icon_cd: StringResource by lazy {
      StringResource("string:create_event_icon_cd", "create_event_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 377, 52),
      ))
    }

@delegate:ResourceContentHash(18_077_608)
internal val Res.string.create_event_page_description: StringResource by lazy {
      StringResource("string:create_event_page_description", "create_event_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2289, 77),
      ))
    }

@delegate:ResourceContentHash(1_999_973_774)
internal val Res.string.create_new_event: StringResource by lazy {
      StringResource("string:create_new_event", "create_new_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2432, 48),
      ))
    }

@delegate:ResourceContentHash(354_078_179)
internal val Res.string.create_new_event_description: StringResource by lazy {
      StringResource("string:create_new_event_description", "create_new_event_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2367, 64),
      ))
    }

@delegate:ResourceContentHash(1_716_150_606)
internal val Res.string.decline: StringResource by lazy {
      StringResource("string:decline", "decline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2481, 27),
      ))
    }

@delegate:ResourceContentHash(1_482_108_474)
internal val Res.string.delete_event_button: StringResource by lazy {
      StringResource("string:delete_event_button", "delete_event_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2509, 43),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.delete_event_confirm: StringResource by lazy {
      StringResource("string:delete_event_confirm", "delete_event_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2553, 36),
      ))
    }

@delegate:ResourceContentHash(765_958_993)
internal val Res.string.delete_event_dialog_message: StringResource by lazy {
      StringResource("string:delete_event_dialog_message", "delete_event_dialog_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2590, 195),
      ))
    }

@delegate:ResourceContentHash(170_986_179)
internal val Res.string.delete_event_dialog_title: StringResource by lazy {
      StringResource("string:delete_event_dialog_title", "delete_event_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2786, 53),
      ))
    }

@delegate:ResourceContentHash(-356_090_209)
internal val Res.string.delete_icon_cd: StringResource by lazy {
      StringResource("string:delete_icon_cd", "delete_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 430, 38),
      ))
    }

@delegate:ResourceContentHash(2_048_927_886)
internal val Res.string.display_name_error: StringResource by lazy {
      StringResource("string:display_name_error", "display_name_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2840, 66),
      ))
    }

@delegate:ResourceContentHash(-1_113_154_767)
internal val Res.string.display_name_field_label: StringResource by lazy {
      StringResource("string:display_name_field_label", "display_name_field_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2907, 48),
      ))
    }

@delegate:ResourceContentHash(-1_385_524_367)
internal val Res.string.edit_details: StringResource by lazy {
      StringResource("string:edit_details", "edit_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2956, 36),
      ))
    }

@delegate:ResourceContentHash(-760_963_424)
internal val Res.string.edit_event_chip: StringResource by lazy {
      StringResource("string:edit_event_chip", "edit_event_chip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2993, 31),
      ))
    }

@delegate:ResourceContentHash(-242_779_978)
internal val Res.string.edit_event_icon_cd: StringResource by lazy {
      StringResource("string:edit_event_icon_cd", "edit_event_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 469, 46),
      ))
    }

@delegate:ResourceContentHash(-423_209_529)
internal val Res.string.edit_event_page_description: StringResource by lazy {
      StringResource("string:edit_event_page_description", "edit_event_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3025, 83),
      ))
    }

@delegate:ResourceContentHash(1_939_107_658)
internal val Res.string.edit_existing_event: StringResource by lazy {
      StringResource("string:edit_existing_event", "edit_existing_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3197, 55),
      ))
    }

@delegate:ResourceContentHash(790_149_640)
internal val Res.string.edit_existing_event_description: StringResource by lazy {
      StringResource("string:edit_existing_event_description", "edit_existing_event_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3109, 87),
      ))
    }

@delegate:ResourceContentHash(289_466_117)
internal val Res.string.edit_icon_cd: StringResource by lazy {
      StringResource("string:edit_icon_cd", "edit_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 516, 32),
      ))
    }

@delegate:ResourceContentHash(-1_815_612_820)
internal val Res.string.edit_membership_field: StringResource by lazy {
      StringResource("string:edit_membership_field", "edit_membership_field", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3253, 57),
      ))
    }

@delegate:ResourceContentHash(-155_880_773)
internal val Res.string.email_error: StringResource by lazy {
      StringResource("string:email_error", "email_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3311, 47),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.email_field_label: StringResource by lazy {
      StringResource("string:email_field_label", "email_field_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3359, 33),
      ))
    }

@delegate:ResourceContentHash(1_844_816_616)
internal val Res.string.event_actions: StringResource by lazy {
      StringResource("string:event_actions", "event_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3393, 41),
      ))
    }

@delegate:ResourceContentHash(1_437_695_557)
internal val Res.string.event_actions_icon_cd: StringResource by lazy {
      StringResource("string:event_actions_icon_cd", "event_actions_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 549, 53),
      ))
    }

@delegate:ResourceContentHash(1_566_824_811)
internal val Res.string.event_date_label: StringResource by lazy {
      StringResource("string:event_date_label", "event_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3435, 40),
      ))
    }

@delegate:ResourceContentHash(1_651_445_672)
internal val Res.string.event_date_placeholder: StringResource by lazy {
      StringResource("string:event_date_placeholder", "event_date_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3476, 46),
      ))
    }

@delegate:ResourceContentHash(1_123_277_364)
internal val Res.string.event_date_time_hint: StringResource by lazy {
      StringResource("string:event_date_time_hint", "event_date_time_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3523, 92),
      ))
    }

@delegate:ResourceContentHash(-660_448_135)
internal val Res.string.event_delete_error: StringResource by lazy {
      StringResource("string:event_delete_error", "event_delete_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3616, 82),
      ))
    }

@delegate:ResourceContentHash(1_840_400_532)
internal val Res.string.event_description_icon_cd: StringResource by lazy {
      StringResource("string:event_description_icon_cd", "event_description_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 603, 65),
      ))
    }

@delegate:ResourceContentHash(673_036_981)
internal val Res.string.event_description_label: StringResource by lazy {
      StringResource("string:event_description_label", "event_description_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3699, 47),
      ))
    }

@delegate:ResourceContentHash(1_046_180_604)
internal val Res.string.event_description_placeholder: StringResource by lazy {
      StringResource("string:event_description_placeholder", "event_description_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3747, 77),
      ))
    }

@delegate:ResourceContentHash(-511_099_166)
internal val Res.string.event_details: StringResource by lazy {
      StringResource("string:event_details", "event_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3825, 41),
      ))
    }

@delegate:ResourceContentHash(-318_339_777)
internal val Res.string.event_details_icon_cd: StringResource by lazy {
      StringResource("string:event_details_icon_cd", "event_details_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 669, 53),
      ))
    }

@delegate:ResourceContentHash(944_828_590)
internal val Res.string.event_end_before_start_error: StringResource by lazy {
      StringResource("string:event_end_before_start_error", "event_end_before_start_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3867, 84),
      ))
    }

@delegate:ResourceContentHash(1_781_124_825)
internal val Res.string.event_end_date_icon_cd: StringResource by lazy {
      StringResource("string:event_end_date_icon_cd", "event_end_date_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 723, 58),
      ))
    }

@delegate:ResourceContentHash(260_556_408)
internal val Res.string.event_end_date_label: StringResource by lazy {
      StringResource("string:event_end_date_label", "event_end_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3952, 40),
      ))
    }

@delegate:ResourceContentHash(1_996_836_468)
internal val Res.string.event_end_time_icon_cd: StringResource by lazy {
      StringResource("string:event_end_time_icon_cd", "event_end_time_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 782, 58),
      ))
    }

@delegate:ResourceContentHash(-1_595_804_305)
internal val Res.string.event_end_time_label: StringResource by lazy {
      StringResource("string:event_end_time_label", "event_end_time_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3993, 36),
      ))
    }

@delegate:ResourceContentHash(-695_540_272)
internal val Res.string.event_form_error: StringResource by lazy {
      StringResource("string:event_form_error", "event_form_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4030, 76),
      ))
    }

@delegate:ResourceContentHash(1_947_379_671)
internal val Res.string.event_invalid_fields_error: StringResource by lazy {
      StringResource("string:event_invalid_fields_error", "event_invalid_fields_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4107, 94),
      ))
    }

@delegate:ResourceContentHash(1_331_341_043)
internal val Res.string.event_location_icon_cd: StringResource by lazy {
      StringResource("string:event_location_icon_cd", "event_location_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 841, 58),
      ))
    }

@delegate:ResourceContentHash(2_031_742_682)
internal val Res.string.event_location_label: StringResource by lazy {
      StringResource("string:event_location_label", "event_location_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4202, 40),
      ))
    }

@delegate:ResourceContentHash(303_349_240)
internal val Res.string.event_location_placeholder: StringResource by lazy {
      StringResource("string:event_location_placeholder", "event_location_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4243, 58),
      ))
    }

@delegate:ResourceContentHash(1_975_016_049)
internal val Res.string.event_required_fields_error: StringResource by lazy {
      StringResource("string:event_required_fields_error", "event_required_fields_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4302, 127),
      ))
    }

@delegate:ResourceContentHash(1_760_090_279)
internal val Res.string.event_schedule: StringResource by lazy {
      StringResource("string:event_schedule", "event_schedule", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4430, 34),
      ))
    }

@delegate:ResourceContentHash(-1_795_329_088)
internal val Res.string.event_schedule_icon_cd: StringResource by lazy {
      StringResource("string:event_schedule_icon_cd", "event_schedule_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 900, 58),
      ))
    }

@delegate:ResourceContentHash(2_026_411_944)
internal val Res.string.event_start_time_icon_cd: StringResource by lazy {
      StringResource("string:event_start_time_icon_cd", "event_start_time_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 959, 60),
      ))
    }

@delegate:ResourceContentHash(-1_720_235_161)
internal val Res.string.event_start_time_label: StringResource by lazy {
      StringResource("string:event_start_time_label", "event_start_time_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4465, 38),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("accept", Res.string.accept)
  map.put("add_comment_placeholder", Res.string.add_comment_placeholder)
  map.put("add_field", Res.string.add_field)
  map.put("admin_actions", Res.string.admin_actions)
  map.put("admin_banner_description", Res.string.admin_banner_description)
  map.put("admin_dashboard_title", Res.string.admin_dashboard_title)
  map.put("admin_icon_cd", Res.string.admin_icon_cd)
  map.put("admin_no_access_description", Res.string.admin_no_access_description)
  map.put("admin_no_access_title", Res.string.admin_no_access_title)
  map.put("admin_page_description", Res.string.admin_page_description)
  map.put("admin_screen_name", Res.string.admin_screen_name)
  map.put("approval", Res.string.approval)
  map.put("approved_at", Res.string.approved_at)
  map.put("approved_by", Res.string.approved_by)
  map.put("attendance_failure_icon_cd", Res.string.attendance_failure_icon_cd)
  map.put("attendance_signed", Res.string.attendance_signed)
  map.put("attendance_signing", Res.string.attendance_signing)
  map.put("attendance_success_icon_cd", Res.string.attendance_success_icon_cd)
  map.put("attendance_try_again", Res.string.attendance_try_again)
  map.put("attendee_count", Res.string.attendee_count)
  map.put("back_icon_cd", Res.string.back_icon_cd)
  map.put("calendar_icon_cd", Res.string.calendar_icon_cd)
  map.put("camera_permission_button", Res.string.camera_permission_button)
  map.put("camera_permission_description", Res.string.camera_permission_description)
  map.put("camera_permission_title", Res.string.camera_permission_title)
  map.put("camera_unavailable", Res.string.camera_unavailable)
  map.put("cancel", Res.string.cancel)
  map.put("change_club", Res.string.change_club)
  map.put("change_club_icon_cd", Res.string.change_club_icon_cd)
  map.put("chevron_icon_cd", Res.string.chevron_icon_cd)
  map.put("choose_event", Res.string.choose_event)
  map.put("clear_search_icon_cd", Res.string.clear_search_icon_cd)
  map.put("club_about_title", Res.string.club_about_title)
  map.put("club_description_label", Res.string.club_description_label)
  map.put("club_description_placeholder", Res.string.club_description_placeholder)
  map.put("club_field_label", Res.string.club_field_label)
  map.put("club_field_label_required", Res.string.club_field_label_required)
  map.put("club_field_type", Res.string.club_field_type)
  map.put("club_form_error", Res.string.club_form_error)
  map.put("club_image_preview", Res.string.club_image_preview)
  map.put("club_image_selected", Res.string.club_image_selected)
  map.put("club_membership_data", Res.string.club_membership_data)
  map.put("club_membership_data_description", Res.string.club_membership_data_description)
  map.put("club_name_label", Res.string.club_name_label)
  map.put("club_name_placeholder", Res.string.club_name_placeholder)
  map.put("club_name_required", Res.string.club_name_required)
  map.put("club_page_label", Res.string.club_page_label)
  map.put("club_profile", Res.string.club_profile)
  map.put("clubs_overview", Res.string.clubs_overview)
  map.put("comment_send_error", Res.string.comment_send_error)
  map.put("comments", Res.string.comments)
  map.put("create_event_button", Res.string.create_event_button)
  map.put("create_event_icon_cd", Res.string.create_event_icon_cd)
  map.put("create_event_page_description", Res.string.create_event_page_description)
  map.put("create_new_event", Res.string.create_new_event)
  map.put("create_new_event_description", Res.string.create_new_event_description)
  map.put("decline", Res.string.decline)
  map.put("delete_event_button", Res.string.delete_event_button)
  map.put("delete_event_confirm", Res.string.delete_event_confirm)
  map.put("delete_event_dialog_message", Res.string.delete_event_dialog_message)
  map.put("delete_event_dialog_title", Res.string.delete_event_dialog_title)
  map.put("delete_icon_cd", Res.string.delete_icon_cd)
  map.put("display_name_error", Res.string.display_name_error)
  map.put("display_name_field_label", Res.string.display_name_field_label)
  map.put("edit_details", Res.string.edit_details)
  map.put("edit_event_chip", Res.string.edit_event_chip)
  map.put("edit_event_icon_cd", Res.string.edit_event_icon_cd)
  map.put("edit_event_page_description", Res.string.edit_event_page_description)
  map.put("edit_existing_event", Res.string.edit_existing_event)
  map.put("edit_existing_event_description", Res.string.edit_existing_event_description)
  map.put("edit_icon_cd", Res.string.edit_icon_cd)
  map.put("edit_membership_field", Res.string.edit_membership_field)
  map.put("email_error", Res.string.email_error)
  map.put("email_field_label", Res.string.email_field_label)
  map.put("event_actions", Res.string.event_actions)
  map.put("event_actions_icon_cd", Res.string.event_actions_icon_cd)
  map.put("event_date_label", Res.string.event_date_label)
  map.put("event_date_placeholder", Res.string.event_date_placeholder)
  map.put("event_date_time_hint", Res.string.event_date_time_hint)
  map.put("event_delete_error", Res.string.event_delete_error)
  map.put("event_description_icon_cd", Res.string.event_description_icon_cd)
  map.put("event_description_label", Res.string.event_description_label)
  map.put("event_description_placeholder", Res.string.event_description_placeholder)
  map.put("event_details", Res.string.event_details)
  map.put("event_details_icon_cd", Res.string.event_details_icon_cd)
  map.put("event_end_before_start_error", Res.string.event_end_before_start_error)
  map.put("event_end_date_icon_cd", Res.string.event_end_date_icon_cd)
  map.put("event_end_date_label", Res.string.event_end_date_label)
  map.put("event_end_time_icon_cd", Res.string.event_end_time_icon_cd)
  map.put("event_end_time_label", Res.string.event_end_time_label)
  map.put("event_form_error", Res.string.event_form_error)
  map.put("event_invalid_fields_error", Res.string.event_invalid_fields_error)
  map.put("event_location_icon_cd", Res.string.event_location_icon_cd)
  map.put("event_location_label", Res.string.event_location_label)
  map.put("event_location_placeholder", Res.string.event_location_placeholder)
  map.put("event_required_fields_error", Res.string.event_required_fields_error)
  map.put("event_schedule", Res.string.event_schedule)
  map.put("event_schedule_icon_cd", Res.string.event_schedule_icon_cd)
  map.put("event_start_time_icon_cd", Res.string.event_start_time_icon_cd)
  map.put("event_start_time_label", Res.string.event_start_time_label)
}
